import React, { FunctionComponent } from 'react'
import { Radio } from '@afterpaytouch/core'
import { Country } from '@afterpay/types'
import { useCountry } from '../../state'
import { useTranslation } from '../../utils/convergence'
import { getLocaleKeyFromDayNumber } from '../../utils/calendar'
import { Weekday } from '../../model'

interface InlinePaymentDayListProps {
  onChange: (day: Weekday) => void
  selectedDay: Weekday
}

export const InlinePaymentDayList: FunctionComponent<InlinePaymentDayListProps> = ({ onChange, selectedDay }) => {
  const { t } = useTranslation()
  const countryCode = useCountry()
  const days: Weekday[] = countryCode === Country.CA || countryCode === Country.US ? [0, 1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5, 6, 0]

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(parseInt(e.target.value) as Weekday)
  }

  return (
    <Radio.Group name='inline-payment-days' value={`${selectedDay}`} onChange={handleChange} kind='Option' indent>
      {days.map((day: Weekday) => (
        <Radio.Button
          key={`inline-payment-day-${day}`}
          label={t(getLocaleKeyFromDayNumber(day))}
          value={`${day}`}
          labelWidth='Full'
          labelPlacement='Top'
          roundedBorder
          testNameSpace={`inline-payment-day-${day}`}
        />
      ))}
    </Radio.Group>
  )
}
